"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var geometry_factory_pitch_1 = require("../../math/geometry/geometry.factory.pitch");
var ike_map_1 = require("../ike.map");
var CollectionModelState = /** @class */ (function () {
    function CollectionModelState(loader) {
        /** Are changes allowed to be made */
        this.frozen = false;
        this.collectedAt = null;
        this.fields = new ike_map_1.IkeMap();
        this.geometries = new ike_map_1.IkeMap();
        this.drawableStates = mobx_1.observable.map();
        this.loader = loader;
    }
    CollectionModelState.createGeometry3D = function (state, captureId) {
        var capture = state.getCapture(captureId);
        if (capture == null) {
            throw new Error("Unable to find capture ".concat(captureId));
        }
        var calibration = state.getCalibration(capture.calibrationid);
        if (calibration == null) {
            throw new Error("Capture ".concat(captureId, ": Unable to find calibration ").concat(capture.calibrationid));
        }
        return geometry_factory_pitch_1.PitchGeometryFactory.create({
            pitch: capture.orientation.pitch,
            distance: capture.distance,
            resolution: capture.resolution,
            calibration: calibration
        });
    };
    CollectionModelState.prototype.getFieldValue = function (fieldId) {
        return this.fields.get(fieldId);
    };
    CollectionModelState.prototype.setFieldValue = function (fieldId, state) {
        if (this.frozen) {
            throw new Error("Field ".concat(fieldId, ": Writing frozen state."));
        }
        this.fields.set(fieldId, state);
    };
    CollectionModelState.prototype.getDrawable = function (captureId, drawableId) {
        var drawableState = this.drawableStates.get(captureId);
        if (drawableState === null || drawableState === void 0 ? void 0 : drawableState.hasDrawable(drawableId)) {
            return drawableState.getDrawable(drawableId);
        }
        throw new Error("Unable to find drawable (id=".concat(drawableId, ") for capture ").concat(captureId));
    };
    /**
     * Does a value for this field id exist
     *
     * @param fieldId id to check
     * @returns True if some data exists, false otherwise
     */
    CollectionModelState.prototype.hasFieldValue = function (fieldId) {
        return this.getFieldValue(fieldId) != null;
    };
    /**
     * Get a related capture object from its id
     *
     * Since not all of our data structures have access to the objectId
     * We need to guess if this is a uuid or a objectId
     *
     * @param captureId Capture.objectId or Capture.uuid
     *
     * @deprecated Use {@link IkeCollectionLoader} directly with async methods instead.
     */
    CollectionModelState.prototype.getCapture = function (captureId) {
        return this.loader.Capture.getById(captureId).value;
    };
    /**
     * Get a calibration given its objectId
     * This is lazy loaded and will return null until the value is loaded
     * @param calibrationId Id of the calibration to fetch
     */
    CollectionModelState.prototype.getCalibration = function (calibrationId) {
        return this.loader.Calibration.getById(calibrationId).value;
    };
    CollectionModelState.prototype.getGeometry = function (captureId) {
        var existing = this.geometries.get(captureId);
        if (existing == null) {
            existing = CollectionModelState.createGeometry3D(this, captureId);
            this.geometries.set(captureId, existing);
        }
        return existing;
    };
    /**
     * Get a collection given its uuid
     *
     * This is lazy loaded and will return null until the value is loaded
     *
     * @param collectionId objectId of the collection to fetch
     */
    CollectionModelState.prototype.getCollection = function (collectionId) {
        return this.loader.CollectionSummary.getById(collectionId).value;
    };
    /**
     * @deprecated This method has a race condition when retrieving linked collections. Use getCollectionModelAsync instead.
     */
    CollectionModelState.prototype.getCollectionModel = function (collectionId) {
        var _a, _b;
        var collectionSummary = (_a = this.loader.CollectionSummary.getById(collectionId)) === null || _a === void 0 ? void 0 : _a.value;
        if (collectionSummary == null) {
            return null;
        }
        return (_b = this.loader.Collection.getModel(collectionSummary.revision)) === null || _b === void 0 ? void 0 : _b.value;
    };
    CollectionModelState.prototype.getCollectionModelAsync = function (collectionId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectionSummary;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loader.CollectionSummary.getById(collectionId).fetch()];
                    case 1:
                        collectionSummary = _a.sent();
                        if (collectionSummary == null) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.loader.Collection.getModel(collectionSummary.revision).fetch()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Freeze the object no changes to field data will be allowed after the state is frozen.
     */
    CollectionModelState.prototype.freeze = function () {
        this.frozen = true;
    };
    return CollectionModelState;
}());
exports.CollectionModelState = CollectionModelState;
//# sourceMappingURL=collection.state.js.map